module.exports = __webpack_public_path__ + "static/nn-c6cc82e1eff9ac83c61efd20b31bd8f9.png";